import React from "react";
import { MenuBar } from "./MenuBar";
import { Navbar } from "./Navbar";

import { Hero } from "./Hero";
import { NewsSection } from "./NewsSection";
import { ArticlesSection } from "./ArticlesSection";
import { TvSection } from "./TvSection";
import { Partidos } from "./Partidos";
import { Diapositivas } from "./Diapositivas";


export const HomePage = () => {
  return (
    <>
      <MenuBar />
      <Navbar />
      <Hero />
      <NewsSection />
      <ArticlesSection />
      <TvSection />
      <Partidos />
      <Diapositivas />

    </>
  );
};

export default HomePage;
